<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">任务信息</div>
      </div>
      <div>
        <span>走访任务单号：</span>
        <span>{{ parseStrEmpty(formData.bizNo) }}</span>
      </div>
    </div>
    <el-form :model="formData" ref="form">
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            果园编号：
            <span>{{ parseStrEmpty(formData.plantationNo) }}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            果园名称：
            <span>{{ parseStrEmpty(formData.plantationName) }}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            果园区域：
            <span>{{ parseStrEmpty(formData.locName) }}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            品控人员：
            <span>{{ parseStrEmpty(formData.qcOperatorName) }}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            走访截止日期：
            <span>{{ parseStrEmpty(formData.visitDueDate) }}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :xs="12">
          <span class="line">
            走访要求：
            <span>{{ parseStrEmpty(formData.visitRequirementDesc) }}</span>
          </span>
        </el-col>
      </el-row>
    </el-form>


    <div v-if="formData.status == 3">
      <div class="title title-mtb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">任务取消原因</div>
        </div>
      </div>
      <div>{{ parseStrEmpty(formData.cancelReason) }}</div>
    </div>
    <div v-else>
      <div class="title title-mtb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">走访信息</div>
        </div>
      </div>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            果园定位：
            <span>{{ parseStrEmpty(formData.geoPosDetails) }}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            走访日期：
            <span>{{ parseStrEmpty(formData.visitedDateTime) }}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            园主/场长：
            <span>{{ parseStrEmpty(formData.ownerName) }}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            施肥种类：
            <span>{{ parseStrEmpty(formData.fertilizerName) }}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            联系方式：
            <span>{{ parseStrEmpty(formData.ownerContact) }}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            土地性质：
            <span>{{ parseStrEmpty(formData.landName) }}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :xs="24">
          <span class="line">
            备注：
            <span>{{ parseStrEmpty(formData.remark) }}</span>
          </span>
        </el-col>
      </el-row>
      <div class="topmargin">
        <TablePublic 
          :colLists="colLists" 
          :tableData="formData.cropDetails" 
          :paginationFlag="false"
          :arraySpanMethod="(
            { row, column, rowIndex, columnIndex })=>
              objectSpanMethod(
                { row, column, rowIndex, columnIndex }, 
                formData.cropDetails
              )
            " 
          :showIndex="false"
        >
          <template slot="index" slot-scope="scope">
            <span>{{ customMergeIndex(indexObj[0], scope.index) }}</span>
          </template>
        </TablePublic>
      </div>
      <div class="title title-mt">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">照片视频</div>
        </div>
      </div>
      <div>
        <img @click="handleFile" class="fileImg" src="https://peelprod.oss-cn-shenzhen.aliyuncs.com/biz/173026022759281382.png" />
        <div class="fileText">照片视频</div>
      </div>
      <div class="title title-mb title-mt">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">走访历史修改记录</div>
        </div>
      </div>
  
      <TablePublic :colLists="colLists2" :tableData="tableData" tableHeight="400" :paginationFlag="false">
        <template slot="modificationDesc" slot-scope="scope">
          <el-tooltip :disabled="!scope.data.modificationDesc" :content="scope.data.modificationDesc" placement="top" popper-class="custom-tooltip-width">
            <div class="modificationDesc">{{ scope.data.modificationDesc }}</div>
          </el-tooltip>
          <el-popover
            placement="right-end"
            width="880"
            trigger="manual"
            v-model="scope.data.visible"
          >
            <div>
              <div class="popover_title">
                <div>果树信息修改详情</div>
                <div class="el-icon-circle-close" @click="scope.data.visible = false"></div>
              </div>
              <div class="popover_over">
                <TablePublic 
                  v-if="scope.data.visible"
                  :colLists="colLists4" 
                  :tableData="scope.data.lastList" 
                  :paginationFlag="false"
                  :arraySpanMethod="(
                    { row, column, rowIndex, columnIndex })=>
                      objectSpanMethod(
                        { row, column, rowIndex, columnIndex }, 
                        scope.data.lastList
                      )
                    " 
                  :showIndex="false"
                >
                  <template slot="index" slot-scope="scope">
                    <span>{{ customMergeIndex(indexObj[2], scope.index) }}</span>
                  </template>
                </TablePublic>
                <TablePublic 
                  v-if="scope.data.visible"
                  style="margin-top: 20px;" 
                  :colLists="colLists3" 
                  :tableData="scope.data.beforeList" 
                  :paginationFlag="false"
                  :arraySpanMethod="(
                    { row, column, rowIndex, columnIndex })=>
                      objectSpanMethod(
                        { row, column, rowIndex, columnIndex }, 
                        scope.data.beforeList
                      )
                    " 
                  :showIndex="false"
                >
                  <template slot="index" slot-scope="scope">
                    <span>{{ customMergeIndex(indexObj[1], scope.index) }}</span>
                  </template>
                </TablePublic>
              </div>
            </div>
            <div slot="reference" @click="showPopover(scope.data, scope.index)" style="width: 150px;">
              <span>“果树信息"修改</span>
              <span class="view_button"><详情></span>
            </div>
          </el-popover>
        </template>
      </TablePublic>
    </div>

    <Box :row="formData"></Box>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component :ref="currentView" :is="currentView"></component>
    </Mdialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getTaskDetail, getAmdRecList } from '@/api/system/manage'
import TablePublic from '@/components/tablePublic'
import fileAttachment from '@/components/fileAttachment.vue'
import Mdialog from '@/components/Mdialog'
import Box from '@/components/nameBox.vue'
export default {
  components: {
    TablePublic,
    fileAttachment,
    Mdialog,
    Box
  },
  data() {
    const _this = this
    return {
      title: '',
      currentView: '',
      dialogVisible: false,
      colLists4: [
        {
          prop: 'code',
          label: '修改后',
          isTrue: true,
          children: [],
        },
      ],
      colLists3: [
        {
          prop: 'code',
          label: '修改前',
          isTrue: true,
          children: [],
        },
      ],
      popoverChildren: [
        {
          prop: 'index',
          label: '序号',
          isTrue: true,
          width: '55',
          formSolt: true,
        },
        {
          prop: 'cultivationMethodSpecValueKey',
          label: '培育方式',
          isTrue: true,
          width: '100'
        },
        {
          prop: 'cropAgeValue',
          label: '果树树龄(年)',
          isTrue: true,
          width: '120'
        },
        {
          prop: 'estimatedUnitPrice',
          label: '预售单价(元)',
          isTrue: true,
          width: '120',
          formatter(row) {
            return _this.formatPrice(row.estimatedUnitPrice)
          },
        },
        {
          prop: 'occupiedArea',
          label: '亩数',
          isTrue: true,
          width: '100'
        },
        {
          prop: 'estimatedUnitOutput',
          label: '预售亩产量(斤)',
          isTrue: true,
          width: '120'
        },
        {
          prop: 'estimatedTotalOutput',
          label: '预估总产量(斤)',
          isTrue: true,
          width: '120'
        },
        {
          prop: 'availableOrderQuantity',
          label: '可订购量(斤)',
          isTrue: true
        },
      ],
      colLists2: [
        {
          prop: 'modificationDesc',
          label: '修改内容',
          isTrue: true,
          align: 'left',
          formSolt: true,
        },
        {
          prop: 'reason',
          label: '修改原因',
          align: 'left',
          isTrue: true,
        },
        {
          prop: 'createDate',
          label: '修改日期',
          isTrue: true,
          width: '100'
        },
        {
          prop: 'createBy',
          label: '修改人',
          isTrue: true,
          width: '100'
        },
      ],
      colLists: [
        {
          prop: 'index',
          label: '序号',
          isTrue: true,
          width: '55',
          formSolt: true,
        },
        {
          prop: 'cultivationMethodSpecValueKey',
          label: '培育方式',
          isTrue: true,
        },
        {
          prop: 'cropAgeValue',
          label: '果树树龄',
          isTrue: true,
        },
        {
          prop: 'occupiedArea',
          label: '果树亩数',
          isTrue: true,
        },
        {
          prop: 'estimatedTotalOutput',
          label: '预估总产量(斤)',
          isTrue: true,
        },
        {
          prop: 'estimatedUnitPrice',
          label: '预售单价(元)',
          isTrue: true,
          formatter(row) {
            return _this.formatPrice(row.estimatedUnitPrice || '-')
          },
        },
        {
          prop: 'availableOrderQuantity',
          label: '可订购量(斤)',
          isTrue: true
        },
      ],
      tableData: [],
      formData: {},
      // table合并列
      spanArr1: [], // 记录每一行的合并数
      pos1: '', // 记录索引
      indexObj: [{},{},{}],// 用于记录索引项对应的实际序号
    }
  },
  computed: {
    ...mapState({ 
      dictList: (state) => state.system.dictList || []
    })
  },
  methods: {
    getDetails(row){
      if(row){
        getTaskDetail(row.id).then(res => {
          if (res.flag) {
            this.formData = {
              ...res.data,
              locName: this.formatLocal(res.data.locDetails, 3),
              visitDueDate: this.parseTime(res.data.visitDueDate, '{y}-{m}-{d}'),
              visitedDateTime: this.parseTime(res.data.visitedDateTime, '{y}-{m}-{d}'),
              qcOperatorName: res.data.qcOperators.map(item=>item.userName).join('，'),
              landName: this.formatDictToText(res.data.fieldTypeKeyList,'landStatus',this.dictList),
              fertilizerName: this.formatDictToText(res.data.fertilizerTypeKey,'fertilizerType',this.dictList)
            }
            this.colLists3[0].children = this.popoverChildren
            this.colLists4[0].children = this.popoverChildren
            this.getAmdRecList(row.id)
            this.getSpanArr(0, this.formData.cropDetails)
          }
        })
      }
    },
    getAmdRecList(id){
      getAmdRecList({formId: id, formType: 'visit_task'}).then(res => {
        if (res.flag) {
          this.tableData = res.data.map(d=>{
            d.lastList = this.formatCropJsonParse(d.currContent)
            d.beforeList = this.formatCropJsonParse(d.orignalContent)
            d.createDate = this.parseTime(d.createTime, '{y}-{m}-{d}')
            d.visible = false
            return d
          })
          console.log(this.tableData)
        }
      })
    },
    showPopover(row, index){
      row.visible = true
      this.getSpanArr(1, row.beforeList)
      this.getSpanArr(2, row.lastList)
    },
    handleFile() {
      this.title = '查看照片视频'
      this.currentView = 'fileAttachment'
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs[this.currentView].getAttachment(this.formData.attachments)
      })
    },
    reset(){
      this.tableData.some(item=>item.visible = false)
    },
    cancel() {
      this.dialogVisible = false
    },
    formatCropJsonParse (obj) {
      if(!obj){
        return []
      }
      let cropObj = JSON.parse(obj)
      let cropDetails = []
      if(cropObj.cropDetails && cropObj.cropDetails.length){
        cropDetails = cropObj.cropDetails.map((d, index)=>{
          d.index = index+1
          d.code = cropObj.bizNo
          return d
        })
      }
      return cropDetails
    },
    // 合并行
    getSpanArr(index, data) {
      this.spanArr1 = []
      for (let i = 0; i < data.length; i++) {
        // 第一列
        if (i === 0) {
          this.spanArr1.push(1)
          this.pos1 = 0
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].cultivationMethodSpecValueKey === data[i - 1].cultivationMethodSpecValueKey) {
            this.spanArr1[this.pos1] += 1
            this.spanArr1.push(0)
          } else {
            this.spanArr1.push(1)
            this.pos1 = i
          }
        }
      }
      this.indexObj[index] = this.dealMergeIndexObj(this.spanArr1)
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }, list) {
      if(!list || !list.length){
        return
      }
      if ([0, 1].includes(columnIndex)) {
        return {
          rowspan: this.mergeIndexRows(row, list, rowIndex, ['cultivationMethodSpecValueKey']),
          colspan: 1,
        }
      }
    },
  },
}
</script>

<style scoped lang='less'>
@import '~@/assets/form.less';
.fileImg {
  width: 100px;
  cursor: pointer;
}
.fileText {
  text-align: center;
  width: 100px;
  margin-top: -10px;
}
.topmargin {
  margin-top: 20px;
}
.line {
  display: flex;
  word-break: keep-all;
  padding: 8px 0;
  span{
    word-break: break-all;
  }
}
</style>